import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './styles/tokens.css';
import './styles/buttons.css';
import './styles/animations.css';
import './styles/type.css';
import './styles.css';
import './components/affiliate/SurfsharkAffiliate.css';
import initializeApp from './appInitializer';
import performance from './utils/performance';
import logger from './utils/logger';

// Initialize app with production-ready features
initializeApp();

// Create a performance marker for initial render
const renderStart = window.performance.now();

const root = createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
);

// Log and record render time after paint
requestAnimationFrame(() => {
  const renderTime = window.performance.now() - renderStart;
  logger.info(`Initial render completed in ${renderTime.toFixed(2)}ms`);
  performance.recordMetric(performance.METRICS.RENDER_TIME, renderTime, { 
    component: 'App', 
    type: 'initial' 
  });
  
  // Start measuring FPS after initial render
  setTimeout(() => {
    performance.measureFPS(2000).then(fps => {
      logger.info(`Initial FPS: ${fps.toFixed(2)}`);
    });
  }, 1000);
});
